{
  "minimumVersion": 22
}
